module.exports = __webpack_public_path__ + "static/media/top-member.03e11b7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/top-member.jpg
// module id = 211
// module chunks = 0